import {mix} from 'polished';
import {DefaultTheme} from 'styled-components';

import {black, white, peach} from '../colors';

export const Theme: DefaultTheme = {
    color: {
        primary: peach,
        secondary: black,
        foreground: peach,
        background: black,
        breadcrumb: peach,
        label: mix(0.4, white, white),
        publishDate: peach
    },
    breakpoint: {
        tablet: '576px',
        desktop: '1144px'
    }
};

// TODO: Dark theme variant
export const DarkTheme: DefaultTheme = Theme;

// TODO: alternative theme converter
export const AlternativeTheme = (currentTheme: DefaultTheme): DefaultTheme => {
    return currentTheme;
};
